import get from 'lodash/get';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import Notification from '../notification';
import MainMenu from '../nav_main_menu/nav_main_menu';
import mainMenuContext from '../nav_main_menu/nav_main_menu_data';
import Search from '../search/search';
import matchMediaDesktop from '../../../utils/client_util';
import { trackGAEvent } from '../../../client/utils/third_party_trackers/ga';
import withTracking from '../../../utils/tracking/components/withTracking';
import {
  defaultClick,
  newsletterSubmit
} from '../../../utils/tracking/events/pageEvents';
import EventModel from '../../../utils/tracking/models';
import axios from 'axios';

class Nav extends Component {
  constructor() {
    super();

    this.state = {
      scale: false,
      menu: false,
      search: false,
      newsletterEmail: ''
    };

    this.setNavScale = this.setNavScale.bind(this);
    this.getCategoryData = this.getCategoryData.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenuIfOpen = this.closeMenuIfOpen.bind(this);
    this.renderCategoryLink = this.renderCategoryLink.bind(this);
    this.renderPageTitle = this.renderPageTitle.bind(this);

    this.newsletterInput = React.createRef();
    this.newsletterInputMobile = React.createRef();
  }

  componentDidMount() {
    if (matchMediaDesktop()) {
      window.addEventListener('scroll', this.setNavScale);
    }

    // Initiate queryly
    if (typeof window.queryly !== 'undefined') {
      const { queryly } = window;
      queryly.init(
        'c99eafd2993b450c',
        document.getElementsByClassName('queryly_search_button')
      );
    }
  }

  setNavScale() {
    const { scrollY } = window;
    const { scale } = this.state;
    const featureFlags = get(this.props, 'config.featureFlags');

    if (this.props.isHome && featureFlags.topNavAdEnabled) {
      this.setState({ scale: false });
    } else {
      if (scale && scrollY <= 20) {
        this.setState({ scale: false });
      }

      if (!scale && scrollY > 20) {
        this.setState({ scale: true });
      }
    }
  }

  getCategoryData(topic) {
    let className = 'nav__link';
    const active = topic.url === get(this.props, 'activeCategory');

    if (active) {
      className = ' nav__active';
    }

    return { className, active };
  }

  setHeaderClass(menu, isHome) {
    const featureFlags = get(this.props, 'config.featureFlags');
    let className = 'page-header';

    if (menu) {
      className += ' page-header--menu';
    }

    // For when we have homepage ad, manually add this for now for now
    if (isHome && featureFlags.topNavAdEnabled) {
      className += ' page-header--with-top-ad';
    }
    return className;
  }

  toggleMenu(event) {
    const { menu } = this.state;
    const html = document.querySelector('html');
    const addRemove = menu ? 'remove' : 'add';
    this.setState({ menu: !menu, search: false });

    html.classList[addRemove]('no-scroll');

    if (event) {
      event.preventDefault();
    }
  }

  closeMenuIfOpen() {
    if (this.state.menu) {
      this.toggleMenu();
    }
  }

  handleLinkTracking(topic, index) {
    const { title } = topic;

    // [DataLayer] trigger nav item click event
    const clickEvent = new EventModel(
      'Top Navigation Click',
      `nav${title}`,
      'siteNavigation',
      `navigation ${title}`,
      index + 1
    );
    this.props.trackClick(clickEvent.getTrackingObject());

    trackGAEvent({
      eventCategory: 'Interaction',
      eventAction: 'Top Nav Category',
      eventLabel: title
    });
  }

  handleFollowLinkTracking(network, index) {
    const { property } = network;

    // [DataLayer] trigger nav item click event
    const clickEvent = new EventModel(
      'Top Nav Follow Us Click',
      `nav${property}`,
      'socialFollow',
      `socialNavigation ${property}`,
      index + 1
    );
    this.props.trackClick(clickEvent.getTrackingObject());

    trackGAEvent({
      eventCategory: 'Social',
      eventAction: 'Top Nav Follow Us',
      eventLabel: property
    });
  }

  renderCategoryLink(topic, index) {
    const { url, title, external } = topic;
    const data = this.getCategoryData(topic);
    const attrs = {
      className: data.className,
      title
    };

    if (data.active) {
      return <span {...attrs}>{title}</span>;
    }

    if (external) {
      attrs.href = `//${url}`;
      return (
        <a
          {...attrs}
          onClick={() => {
            // trackGAEvent({
            //   eventCategory: 'Interaction',
            //   eventAction: 'Top Nav Category',
            //   eventLabel: title
            // });
            this.handleLinkTracking(topic, index);
          }}
        >
          {title}
        </a>
      );
    }
    attrs.to = url;
    return (
      <Link
        {...attrs}
        onClick={() => {
          // trackGAEvent({
          //   eventCategory: 'Interaction',
          //   eventAction: 'Top Nav Category',
          //   eventLabel: title
          // });
          this.handleLinkTracking(topic, index);
        }}
      >
        {title}
      </Link>
    );
  }

  renderPageTitle() {
    const { isHome, title } = this.props;
    const { scale } = this.state;
    let className = 'page-header__title';

    if (scale) {
      className += ' page-header__title--scaled';
    }

    if (isHome) {
      return <h2 className={className}>{title}</h2>;
    }

    return (
      <Link to="/" className={className}>
        {title}
      </Link>
    );
  }

  render() {
    const {
      notification,
      isHome,
      topics,
      config,
      topNewsletterSignup
      // newsletterLink,
      // subscribeLink
    } = this.props;
    const { menu, search, scale } = this.state;
    const site = get(config, 'site', '');
    const social = get(mainMenuContext, `social.${site}`, []);

    // When we want to A/B test this link

    return (
      <header
        className={this.setHeaderClass(menu, isHome)}
        onClick={this.closeMenuIfOpen}
      >
        <div className="nav__main-items">
          {this.renderPageTitle()}
          <ul
            className={`nav__extras nav__extras--left ${
              scale ? 'nav__extras--scaled' : ''
            }`}
          >
            <a
              className={scale ? 'nav__menu__scaled' : 'nav__menu'}
              onClick={this.toggleMenu}
            >
              <img
                src="https://images.fastcompany.net/image/upload/v1540915228/fcweb/3_Line_Burger_ffffff2x_tiojxh.svg"
                className="nav__menu__hamburger"
                alt="Menu"
              />
            </a>

            {/* <li
              className={
                scale
                  ? 'nav__extras-item nav__menu-lower__scaled'
                  : 'nav__extras-item nav__menu-lower'
              }
            >
              <a className="nav__newsletter" href={newsletterLink}>
                Newsletter
              </a>
            </li>
            <li
              className={
                scale
                  ? 'nav__extras-item nav__menu-lower__scaled'
                  : 'nav__extras-item nav__menu-lower'
              }
            >
              <a href={subscribeLink} className="nav__subscribe">
                Subscribe
              </a>
            </li> */}
          </ul>

          <ul
            className={`nav__extras nav__extras--right ${
              scale ? 'nav__extras--scaled' : ''
            }`}
          >
            <li className="nav__extras-item">
              {social.map((network, index) => (
                <a
                  key={network.url}
                  href={network.url}
                  className={`nav__social-button nav__social-button--${
                    network.property
                  }`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    // trackGAEvent({
                    //   eventCategory: 'Social',
                    //   eventAction: 'Top Nav Follow Us',
                    //   eventLabel: network.property
                    // });
                    this.handleFollowLinkTracking(network, index);
                  }}
                >
                  <i
                    className={`nav__icon nav__icon--${network.property} icon-${
                      network.property
                    }`}
                  />
                </a>
              ))}
            </li>
            <li className="nav__extras-item">
              <button className="queryly_search_button  nav__search-trigger">
                <i className="icon-search-glass" />
              </button>
            </li>
          </ul>
        </div>
        <nav className="nav">
          <ul className="nav__list">
            {topics.map((topic, index) => (
              <li
                key={topic.title}
                className={
                  (topic.removeOnScale
                    ? 'nav__item nav__item__remove'
                    : 'nav__item') + (topic.bold ? ' nav__item__bold' : '')
                }
              >
                {this.renderCategoryLink(topic, index)}
              </li>
            ))}
          </ul>
        </nav>
        <Search
          skin="light"
          modifier="overlay"
          active={search}
          modal={true}
          closeModal={this.toggleSearchModal}
        />
        <MainMenu
          closeMenu={this.toggleMenu}
          mainMenuVisible={menu}
          scaled={this.state.scale}
          {...mainMenuContext}
          config={config}
          topics={topics}
        />
        {topNewsletterSignup.show ? (
          <div className="topnav-newsletter-container">
            <div className="topnav-newsletter-container__label">
              <span className="topnav-newsletter-container__icon">
                <img
                  alt="logo"
                  src="https://images.fastcompany.net/image/upload/v1559074510/fcweb/DailyCompass_compass_RGB_outlines_yn4acq.svg"
                />
              </span>
              <span class="topnav-sign-up-text">
                Sign up for our daily email.
              </span>
              <span
                className="closeNewsletters"
                onClick={() => {
                  topNewsletterSignup.callback();
                }}
              >
                <img
                  alt="close newsletter"
                  src="https://images.fastcompany.net/image/upload/v1559221848/fcweb/FCCompass_close-x_ruwqtw.svg"
                />
              </span>
            </div>
            <span class="topnav-thank-you-text">Thank you for signing up!</span>
            <div className="topnav-newsletter-container__form">
              <form
                onChange={() => {
                  const el = document.querySelector(
                    '.topnav-newsletter-container__form'
                  );
                  el.className = 'topnav-newsletter-container__form';
                }}
                onSubmit={event => {
                  const webApiUrl =
                    'https://www.getrevue.co/api/v2/subscribers';
                  const tokenStr = 'iHKTPKgaDUSYFKnbsZlEnbPT119pM-3e';
                  const submissionStatus = {
                    success: false,
                    response: null
                  };
                  axios
                    .post(
                      webApiUrl,
                      {
                        email: this.state.newsletterEmail,
                        first_name: 'First Name Placeholder',
                        last_name: 'Last Name Placeholder',
                        double_opt_in: false
                      },
                      {
                        headers: {
                          Authorization: `Token ${tokenStr}`
                        }
                      }
                    )
                    .then(response => {
                      // Success
                      submissionStatus.success = true;
                      submissionStatus.response = response;

                      this.newsletterInput.current.setAttribute(
                        'placeholder',
                        `You're signed up!`
                      );
                      this.newsletterInput.current.value = '';
                      this.newsletterInputMobile.current.setAttribute(
                        'placeholder',
                        `You're signed up!`
                      );
                      this.newsletterInputMobile.current.value = '';

                      const successfulSubmission = new EventModel(
                        'Newsletter Submitted Successfully',
                        `Newsletter Submitted Successfully`,
                        'Newsletter Submitted Successfully',
                        `Newsletter Submitted Successfully`
                      );
                      // Track succesful Newsletter signup
                      this.props.trackNewsletterSubmission(
                        successfulSubmission.getTrackingObject()
                      );
                    })
                    .catch(err => {
                      // Fail
                      submissionStatus.response = err;
                      let placeholder =
                        err.response.data.error.email[0] ===
                        'This email address has already been subscribed'
                          ? 'Already subscribed'
                          : err.response.data.error.email[0];
                      placeholder =
                        err.response.data.error.email[0] ===
                          'This is not a valid email address' ||
                        err.response.data.error.email[0] ===
                          "We're really going to need an email address"
                          ? 'Please enter a valid email address'
                          : placeholder;
                      this.newsletterInput.current.setAttribute(
                        'placeholder',
                        placeholder
                      );
                      this.newsletterInputMobile.current.setAttribute(
                        'placeholder',
                        placeholder
                      );
                      this.newsletterInput.current.value = '';
                      this.newsletterInputMobile.current.value = '';
                      const el = document.querySelector(
                        '.topnav-newsletter-container__form'
                      );
                      el.className =
                        'topnav-newsletter-container__form topnav-newsletter-container__form--error';
                    })
                    .then(() => {
                      // Always
                      const submitEvent = new EventModel(
                        'Newsletter Submitted',
                        `Newsletter Submitted`,
                        'Newsletter Submitted',
                        `Newsletter Submitted`
                      );
                      submitEvent.addTrackingAttributes({
                        submissionStatus
                      });
                      if (submissionStatus.success === true) {
                        let el = document.querySelector('.topnav-sign-up-text');
                        el.style.display = 'none';
                        el = document.querySelector('.topnav-thank-you-text');
                        el.style.display = 'block';
                        el = document.querySelector(
                          '.topnav-newsletter-container__form'
                        );
                        el.style.display = 'none';
                        // el = document.querySelector(
                        //   '.topnav-newsletter-container__icon'
                        // );
                        // el.className =
                        //   'topnav-newsletter-container__icon topnav-newsletter-container__icon--mobile-success';
                      }
                      // Track succesful Newsletter click
                      this.props.trackClick(submitEvent.getTrackingObject());
                    });

                  event.preventDefault();
                }}
              >
                <input
                  class="topnav-desktop-input"
                  ref={this.newsletterInput}
                  type="text"
                  placeholder="Enter your email address"
                  onChange={event => {
                    this.newsletterInput.current.setAttribute(
                      'placeholder',
                      'Enter your email address'
                    );

                    this.setState({
                      newsletterEmail: event.target.value
                    });
                  }}
                />
                <input
                  class="topnav-mobile-input"
                  ref={this.newsletterInputMobile}
                  type="text"
                  placeholder="Sign up here for our new daily mail."
                  onChange={event => {
                    this.newsletterInputMobile.current.setAttribute(
                      'placeholder',
                      'Enter your email address'
                    );

                    this.setState({
                      newsletterEmail: event.target.value
                    });
                  }}
                />
                <button type="submit">SUBMIT</button>
              </form>
            </div>
          </div>
        ) : null}
        {notification.message ? (
          <Notification
            message={notification.message}
            callback={notification.callback}
          />
        ) : null}
      </header>
    );
  }
}

Nav.defaultProps = {
  trackClick: () => false,
  trackNewsletterSubmission: () => false,
  topNewsletterSignup: {}
};

Nav.propTypes = {
  notification: PropTypes.shape({}).isRequired,
  isHome: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subscribeLink: PropTypes.string.isRequired,
  newsletterLink: PropTypes.string.isRequired,
  trackClick: PropTypes.func,
  trackNewsletterSubmission: PropTypes.func,
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool, // eslint-disable-next-line react/no-unused-prop-types
      title: PropTypes.string.isRequired, // eslint-disable-next-line react/no-unused-prop-types
      url: PropTypes.string.isRequired // eslint-disable-next-line react/no-unused-prop-types
    })
  ).isRequired,
  config: PropTypes.shape({}).isRequired,
  topNewsletterSignup: PropTypes.shape({})
};

const mapTrackingToProps = trackEvent => ({
  trackClick: pageObject => trackEvent(defaultClick(pageObject)),
  trackNewsletterSubmission: pageObject =>
    trackEvent(newsletterSubmit(pageObject))
});

const trackedNav = withTracking(mapTrackingToProps)(Nav);

export default trackedNav;
